import React, { useState, useEffect } from "react";
import {
    Link,
    useLocation,
    useHistory
} from "react-router-dom";

import {
    Layout,
    Menu,
} from 'antd';

import {
    FiHome,
    FiGrid,
    FiLock
} from "react-icons/fi";

import { 
    FaTelegramPlane,
    FaTwitter,
    FaBook,
    FaGem,
    FaRocket
} from "react-icons/fa";

const { Sider } = Layout;

const menuLinks = [
    {
        name: 'Home',
        url: '/dashboard/',
        icon: <FiHome />,
        key: 1
    },
    {
        name: 'Presales',
        icon: <FaRocket />,
        key: 2,
        subItems: [
            {
                name: 'Create Presale',
                url: '/create-presale/',
                key: 3
            },
            {
                name: 'Manage Presales',
                url: '/manage-presales',
                key: 4
            },
            {
                name: 'Presales List',
                url: '/presales/all',
                key: 5
            },
            // {
            //     name: 'Create token',
            //     url: '/create-token/',
            //     key: 5
            // }
        ]
    },
    {
        name: 'Locks',
        icon: <FiLock />,
        key: 7,
        subItems: [
            {
                name: 'Create Token Lock',
                url: '/create-token-lock/',
                key: 8
            },
            {
                name: 'Create Liquidity Lock',
                url: '/create-liquidity-lock/',
                key: 9
            },
            {
                name: 'Token Locks',
                url: '/tokenlock/token',
                key: 10
            },
            {
                name: 'Liquidity Locks',
                url: '/liquiditylocks/liquidity',
                key: 11
            }
        ]
    },
    {
        name: 'KYC & Audit',
        url: '/kyc-audit',
        icon: <FaGem />,
        key: 1
    },
    {
        name: 'Docs',
        url: '/docs',
        icon: <FaBook />,
        key: 1
    },
    {
        name: 'Telegram',
        url: '/telegram',
        icon: <FaTelegramPlane />,
        key: 1
    },
    {
        name: 'Twitter',
        url: '/twitter',
        icon: < FaTwitter />,
        key: 1
    },
];

function getItem(label, key, icon, children, type) {
    return {
        key,
        icon,
        children,
        label,
        type,
    };
}

const menu_lists = [
    getItem(<Link to="/dashboard">Home</Link>, 'dashboard', <FiLock />),
    getItem('Presales', 'sub1', <FiGrid />, [
        getItem(<Link to="/create-presale">Create Presale</Link>, 'create-presale'),
        getItem(<Link to="/manage-presales">Manage Presales</Link>, 'manage-presales')
    ]),
    getItem('Locks', 'sub2', <FiLock />, [
        getItem(<Link to="/create-lock">Create Lock</Link>, 'create-lock'),
        getItem(<Link to="/token-locks">Token Locks</Link>, 'token-locks'),
        getItem(<Link to="/liquidity-locks">Liquidity Locks</Link>, 'liquidity-locks')
    ]),
];

const rootSubmenuKeys = ['sub1', 'sub2'];
  

function Sidebar(props) {

    const collapsed = props.collapsed;
    const [isMobile, setIsMobile] = useState(false);

    const location = useLocation();
    const [openKeys, setOpenKeys] = useState([]);

    const onOpenChange = (keys) => {
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);

        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };

    useEffect(() => {
        if (!menuLinks.find(item => item.url === location.pathname)) {
            if (menuLinks.find(item => item.subItems && item.subItems.find(item => item.url === location.pathname))) {
                const currentSubItem = menuLinks.find(item => item.subItems && item.subItems.find(item => item.url === location.pathname))
                setOpenKeys([currentSubItem.name])
            }
            return
        }
    }, [location.pathname]);
    

    return (

        <Sider
            width={200}
            trigger={null}
            collapsible
            collapsed={collapsed}
            className="site-layout-background site-theme-sider"
            breakpoint="lg"
            collapsedWidth={!isMobile ? "48" : "0"}
            onBreakpoint={(broken) => {
                console.log(broken);
            }}
            onCollapse={(collapsed, type) => {
                setIsMobile(!isMobile)
                console.log(collapsed, type);
            }}
        >
            <Menu
                className="nav-sidebar"
                mode="inline"
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                selectedKeys={[location.pathname]}
                // items={menu_lists}
            >
                {
                    menuLinks.map(
                        link => (
                            link.subItems ?
                            <Menu.SubMenu
                                key={link.name} 
                                title={link.name}
                                icon={link.icon}
                            >
                                {
                                    link.subItems.map(
                                        subItem => (
                                            <Menu.Item key={subItem.url}>
                                                <Link to={subItem.url}>{subItem.name}</Link>
                                            </Menu.Item>
                                        )
                                    )
                                }
                            </Menu.SubMenu> :
                            <Menu.Item key={link.url} icon={link.icon}>
                                <Link to={link.url}>{link.name}</Link>
                            </Menu.Item>
                        )
                    )
                }
            </Menu>
        </Sider>

    );
}

export default Sidebar;
